import G from './Getters';
import { post } from './io';
import A from './ActionCreators';
import getBlobFromUrl from './getBlobFromUrl';
import SciugoFormData from './SciugoFormData';
import C from './Constants';
import { createImageSetsFromMultidimensionalImage } from './multidimUtils';
import onSimpleImageUploadSuccess from './onSimpleImageUploadSuccess';
import onMultidimUploadSuccess from './onMultidimUploadSuccess';
import hasSimpleImageFileExtension from './hasSimpleImageFileExtension';
import { isCLI } from './versionConfig.js';

function getRemoteStorageResourceIdIfAllowed({
  remoteStorageSpecification,
  version,
  imageId,
  storageLocation
}){



  if( !remoteStorageSpecification ){
    return;
  }
  if( storageLocation !== 'test-server' ){
    return;
  }


  let spec = remoteStorageSpecification.find(s => s.imageId === imageId && s.version === version);

  if( spec ){
    return spec.remoteStorageResourceId;
  }
}

let clearPostData = (imageSpec,dispatch) => {
  dispatch(A.clearPostData({imageSpec}))
}


let onServerFailure = (imageSpec,dispatch) => res => {



  
  if( res && res.json && !res.json.canRetry ){

    clearPostData(imageSpec,dispatch);

    dispatch(A.notifyMediaPersistenceError({
      imageSpec,
      errorType:"imageProcessingError",
    }))


    


  }else if( imageSpec.version === 'raw' ){
    clearPostData(imageSpec,dispatch);

    dispatch(A.notifyMediaPersistenceError({
      imageSpec,
      errorType:C.postResourceError
    }))
  }

  return false;
}


export default function persistMediaWithPresignedUrls(args){
  return (dispatch,getState) => {



    console.log("PERSIST MEDIA WITH PRESIGNED URLS");


    let {imagesToSync, storageLocation, state, remoteStorageSpecification} = args;
    state = state || getState();




    imagesToSync = imagesToSync || G.getMediaItemsWithPresignedUrls(state);

    let persistPromises = imagesToSync.map((imageSpec,iiImageFile) => {

      let { _id, version } = imageSpec;
      let imageVersionReferenceContainer = state.media[_id];
      let imageInfoContainer = imageVersionReferenceContainer[version];




      let localResourceUrl = imageInfoContainer.localBlobUrl;


      if( ! localResourceUrl ){
        debugger;
      }

      return getBlobFromUrl(localResourceUrl).then(blob => {
        let postData = G.getPostInfo(state,imageSpec);
        if( !postData ){
          return;
        }

        let formData = new SciugoFormData();
        if( process.env.NODE_ENV !== 'production' ){

          let testSuppliedRemoteStorageResourceId = getRemoteStorageResourceIdIfAllowed({imageId:_id, version, storageLocation, remoteStorageSpecification});
          if( testSuppliedRemoteStorageResourceId ){
            postData = JSON.parse(JSON.stringify(postData));
            postData.fields['key'] = testSuppliedRemoteStorageResourceId;

          }
        }

        Object.keys(postData.fields).forEach(key => {
          formData.append(key, postData.fields[key]);
        })




        console.log("WE GOT HERE!");





        let specifiedImageIds = args.args && args.args.imageIds || []
          let indexOfUploads = specifiedImageIds.findIndex(imgId => {
            return imgId === imageSpec._id
          });


        let argsFilenameList = args.args && args.args.filenames; 
        let argsFilename = argsFilenameList && argsFilenameList[indexOfUploads];
        let pendingImage = G.getImage(getState(),{imageId:_id,pendingRecords:true})
        let pendingImageFilename = pendingImage && pendingImage.filename;
        let filename = argsFilename || pendingImageFilename;


        let filenameExt = filename.split('.').slice(-1)[0]
        let isMultidimUpload = !hasSimpleImageFileExtension(filenameExt.toLowerCase());



        
        
        let endpointArgs; 
        let onSuccess;

        let blobToSend = blob;

        if( isMultidimUpload ){
          let multidimEndpoint;
          if (process.env.NODE_ENV === 'production') {
            multidimEndpoint = 'https://d3ms3calyu3aud.cloudfront.net';
          } else {
            multidimEndpoint = 'http://0.0.0.0:5005';
          }
          endpointArgs = {
            routeOrigin: multidimEndpoint,
            route:'/upload',
          }
          onSuccess = onMultidimUploadSuccess;

          if( isCLI() ){
            blobToSend = require('fs').createReadStream("../test/files/"+filename);
          }

        }else{

          endpointArgs = {
            routeOrigin:postData.url,
            route:'',
          }

          console.log("SIMPLE IMAGE UPLOAD SUCCES FUNCTION!");
          onSuccess = onSimpleImageUploadSuccess;

        }

        

        

        formData.append('file',blobToSend)
        formData.append('filename',filename);


        if( ! postData.fields ){
          return;
          debugger;
        }

        console.log("BEFORE PERSIST MEDIA POST!");

        return post({
          ...endpointArgs,
          body:formData,
          stringify:false,
          state,
          onSuccess:onSuccess({
            remoteStorageResourceId:postData.fields.key,
            imageSpec,
            storageLocation,
            args
          },dispatch),
          onServerFailure:onServerFailure(imageSpec,dispatch),
          onFetchError:(err) => {

            debugger;


            //For ease of navigation:
            //'onFetchError' is called when the `fetch` call in SciugoFetch leads to a rejected promise --> catch(err => {...});

            dispatch(A.alertServer({
              cliMessage:"Fetch was caught when posting presigned urls with images."
            }))

            onServerFailure(imageSpec,dispatch)();

          },
          shouldRetry:(res,attemptsMade) => {
            if( !endpointArgs.routeOrigin ){
              if( res.status !== 204 && attemptsMade < 3){
                console.log("NEED TO RETRY BECAUSE STATUS WAS NOT 204!");
                return true;
              }
            }
          }
        },dispatch)
      })
    })

    return Promise.all(persistPromises);

  }
}
